import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, signInWithGoogle } from '../firebase';
import { signOut } from 'firebase/auth';
import './Authentication.css';

// List of allowed email addresses
const ALLOWED_EMAILS = [
  // Add your allowed email addresses here

  // 'user@example.com',
  'apinnovation3@gmail.com',
  'amytpathak@gmail.com',
  'devendrapatil152@gmail.com',
  'shekhararya613@gmail.com'
];

const Authentication = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      setLoading(true);
      const user = await signInWithGoogle();

      // Check if user's email is in the allowed list
      const userEmail = user?.email?.toLowerCase().trim();
      const allowedEmails = ALLOWED_EMAILS.map(email => email.toLowerCase().trim());

      if (!userEmail || !allowedEmails.includes(userEmail)) {
        // Sign out the user if email is not allowed
        await signOut(auth);
        setError('Access denied. Your email is not authorized to access this application.');
        console.log('Attempted login with email:', userEmail);
        console.log('Allowed emails:', allowedEmails);
        return;
      }

      navigate('/dashboard'); // Redirect to dashboard after login
    } catch (error) {
      setError(error.message);
      console.error('Authentication error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">Welcome</h1>
        <p className="auth-subtitle">Sign in to continue</p>

        {error && <div className="error-message">{error}</div>}

        <button
          className="google-signin-btn"
          onClick={handleGoogleSignIn}
          disabled={loading}
        >
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google logo"
            className="google-icon"
          />
          <span>Continue with Google</span>
        </button>
      </div>
    </div>
  );
};

export default Authentication;